/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardResponse {
    getFixupPrototypeFunction() { return ComplianceStandardResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardResponse>): ComplianceStandardResponse {
        let obj = Object.assign(new ComplianceStandardResponse(), model);
        ComplianceStandardResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardResponse>): ComplianceStandardResponse {
        if (!model) return null;
        return ComplianceStandardResponse.newInstance(<ComplianceStandardResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardResponse) {
        if (!obj) return;

        models.ComplianceStandardResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * summary listed successfully
     */
    message: string;

    /**
     * execute data.
     */
    assessment_jobs_by_account: any;

}
